
    const data = {"name":"src/core/icons/bed","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 7h-8v7H3V5H1v15h2v-3h18v3h2v-9a4 4 0 0 0-4-4M7 13a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            